import React from "react";
import "./styles.less";
import { Button } from "../../components/Button";
import { useTranslation } from "react-i18next";
import { CommonConsult } from "../../blocks/common-consult";

export const SolutionConsult = () => {
  const { t } = useTranslation();
  return (
    <section>
      <div className="solution-consult">
        <div className="solution-consult-bg">
          <img src={"//files.authing.co/authing-website/tryblock-bg-img.png"} alt="authing solution consult" />
        </div>
        <div className="inner">
          <div>
            <div className="content-warp">
              <div>
                <div className="slogin">{t("common.common-consult")}</div>
                <div className="descript">{t("common.common-consult-descript")}</div>
              </div>
              <CommonConsult aside={<Button>{t("common.common-consult")}</Button>} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
